import { render, staticRenderFns } from "./StatusRibbon.vue?vue&type=template&id=34aeebd4&scoped=true"
import script from "./StatusRibbon.vue?vue&type=script&lang=js"
export * from "./StatusRibbon.vue?vue&type=script&lang=js"
import style0 from "./StatusRibbon.vue?vue&type=style&index=0&id=34aeebd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aeebd4",
  null
  
)

export default component.exports